<template>
  <invoicing-admin-layout>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="3">
          <v-card flat>
            <v-card-actions>
              <v-text-field placeholder="Search Companies" prepend-icon="fa-search" v-model="search" type="text"
                clearable clear-icon="fa-times" @click:clear="resetSearch" @keyup="applySearch"
                class="search-box"></v-text-field>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-select :items="status" :clearable="true" placeholder="Status" item-value="id" item-text="name"
                v-on:change="FilterByStatus($event)" class="search-box"></v-select>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" v-if="$globalConfig.APP_NAME == 'direct'">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-select :items="leads" :clearable="true" placeholder="Lead From" item-value="id" item-text="name"
                v-on:change="FilterByLead($event)" class="search-box"></v-select>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" v-if="$globalConfig.APP_NAME == 'partner'">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-select :items="partners" :clearable="true" placeholder="Partner" item-value="id" item-text="name"
                v-on:change="FilterByPartner($event)" class="search-box" :loading="partnerLoading" hide-no-data
                :disabled="partnerLoading" @change="resetSearchTerm" attach >
                  <template  prepend-item>
                            <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
                  </template>
                  <template v-slot:prepend-item>
                            <v-list-item>
                                <v-list-item-content style="padding: 12px 0 0 0;">
                                    <v-text-field v-model="searchTerm" label="Search Partner" @input="onSearchInput"
                                        class="search-term" style="margin:0;" />
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                        </template>
              </v-select>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table"
            :types="{ 'table-heading': '' }"></v-skeleton-loader>
          <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table"
            :types="{ 'table-heading': '', 'table-thead': 'heading@1', 'table-row': 'text@1' }"
            class="slider-table"></v-skeleton-loader>

          <v-data-table :headers="computedHeaders" :options.sync="options" :server-items-length="serverItemsLength"
            v-show="!loading" :items="users" item-key="id">

              <template v-slot:item.total_owners="{ item }">
                  <span v-if="item.total_owners" class="clickable-count"  :class="{directColor : $globalConfig.APP_NAME === 'direct' ,partnerColor : $globalConfig.APP_NAME === 'partner'}"
                    @click.stop="openDialog($event,item.owners_details,'Company Admins')">{{ item.total_owners}}
                  </span>
                  <span v-else>{{ item.total_owners }}</span>
              </template>

              <template v-slot:item.id="{ item }">
                <v-btn color="primary" class="mr-2 " @click.prevent="openRenewalDateDrawer(item.id,item.invoice_type)">Renewal Date</v-btn>
              </template>

          </v-data-table>

          <renewal-date-drawer :renewalDateDrawer="renewalDateDrawer" :companyId="companyId" :invoiceType="invoiceType"  @update:invoiceType="invoiceType = $event"></renewal-date-drawer>
          <DialogComponent :isOpen="dialog" :dialogTitle="dialogTitle" :dialogData="dialogData" @close="closeDialog" />

        </v-col>
      </v-row>
    </v-container>
  </invoicing-admin-layout>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import InvoicingAdminLayout from '@/layouts/InvoicingAdmin';
import companyAPI from '@/api/company.js';
import RenewalDateDrawer from '@/components/invoicingadmin/RenewalDateDrawer';
import DialogComponent from '@/components/invoicingadmin/Dialog';
import improveAPI from '@/api/superadmin.js';
import partnerAPI from '@/api/partner.js';


export default {
  name: 'InvoicingAdminCompanyList',
  components: {
    InvoicingAdminLayout,
    RenewalDateDrawer,
    DialogComponent,
  },
  data() {
    return {
      headers: [
        { text: 'Company', value: 'company_name', sortable: false },
        {
          text: "Banding",
          value: "banding_description.name",
          sortable: false
        },
        {
          text: '# Users',
          value: 'total_members',
          sortable: false,
        },
        // {
        //   text: "# Courses",
        //   value: "total_courses",
        //   sortable: false
        // },
        // {
        //   text: 'Name',
        //   value: 'company_owner_name',
        //   sortable: false,
        // },

        // {
        //   text: 'Email',
        //   value: 'company_owner_email',
        //   sortable: false,
        // },

        {
          text: 'Status',
          value: 'state_description',
          sortable: false,
        },
        {
          text: "Created",
          value: "created_at"
        },
        {
          text: "Renewal",
          value: "renewal_at",
          sortable: false
        },
        {
          text: "Invoiced",
          value: "invoice_type",
          sortable: false
        },
        {
          text: "Company Admins",
          value:"total_owners",
          sortable: false
        },
         
        {
          text: '',
          value: 'id',
          sortable: false,
          align: 'end',
        },

      ],
      renewalDateDrawer: false,
      companyId: '',
      users: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      status: [
        { id: 1, name: 'Free Trial' },
        { id: 2, name: 'Free Trial Expired' },
        { id: 3, name: 'Active Membership' },
        { id: 4, name: 'Suspended Membership' },
        { id: 5, name: 'Free Trial Extended' },
      ],
      selectedStatus: "",
      timer: null,
      leads: [],
      selectedLead: "",
      dialog: false,
      dialogTitle : '',
      dialogData: [],
      selectedAction: null,
      partners: [],
      selectedPartner: "",
      searchTerm:"",
      partnerLoading: false,
      partnersCopy:[],
      invoiceType: ''
    };
  },
  computed: {
    computedHeaders() {
      let headers = [...this.headers];
      if (this.$globalConfig.APP_NAME == 'partner') {
        headers.splice(1, 0,
          { text: 'Partner', value: 'partner', sortable: false },
        );
      }
      if (this.$globalConfig.APP_NAME == 'direct') {
        headers.splice(7, 0,
          { text: 'Lead From', value: 'lead_from', sortable: false });
      }
      return headers;
    },
    serverItemsLength: function () {
      if (this.pagination && this.pagination.total) {
        return this.pagination.total;
      } else {
        return this.users.length;
      }
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    maxUsers: function () {
      return 500;
    },
    userLimit: function () {
      return this.serverItemsLength >= this.maxUsers ? true : false;
    },
    
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  mounted() {
    this.setEventBus();
    this.loadSearch();

    if (this.$globalConfig.APP_NAME == 'direct') {
      this.getLeadsData();
    }
    if(this.$globalConfig.APP_NAME == 'partner') { 
      this.getPartnersList();
    }
  },
  watch: {
    options: {
      handler() {
        this.getCompanies();
      },
      deep: true,
    },
  },
  methods: {
    applySearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.options.page = 1;
        if (this.search != null) {
          const searchKey = this.$globalConfig.APP_NAME == 'senso'
            ? '&search=company.company_name:'
            : '&search=company_name:';
          this.searchParams = searchKey + this.search;
        } else {
          this.searchParams = '';
        }
        this.getCompanies();
        this.saveSearch();
      }, 1000);
    },
    resetSearch() {
      this.options.page = 1;
      this.search = '';
      this.applySearch();
      this.saveSearch();
    },
    getCompanies() {
      this.loading = true;

      let updatedQueryString = '';
      if (this.options.sortDesc.length) {
        // Create an instance of URLSearchParams
        const queryString = new URLSearchParams(this.params);
        // Convert the URLSearchParams instance to an object
        const paramsObject = Object.fromEntries(queryString.entries());
        paramsObject.sortedBy = this.options.sortDesc[0] ? 'desc' : 'asc';

        // Update the URLSearchParams with the modified paramsObject
        const updatedParams = new URLSearchParams(paramsObject);

        // Convert the updated URLSearchParams back to a query string
        updatedQueryString = `?${updatedParams.toString()}`;
      } else {
        updatedQueryString = this.params
      }
      
      
      companyAPI
        .getCompanies(updatedQueryString, this.searchParams, this.selectedStatus, this.selectedLead, this.selectedPartners)
        .then((resp) => {
          this.users = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },

    setEventBus() {
      EventBus.$on('USERS_UPDATED', (payload) => {
        // this.params = payload;
        this.getCompanies();
      });
      EventBus.$on('USERS_ADDED', (payload) => {
        // this.params = payload;
        this.getCompanies();
      });
      EventBus.$on('closePanel', (payload) => {
        this.getOwners();
      });
      EventBus.$on('RENEWALDATE_DRAWER_STATE', (state) => {
        this.renewalDateDrawer = state;
      });
      EventBus.$on('RENEWAL_DATE_STATE_UPDATED', () => {
        this.renewalDateDrawer = false;
        this.getCompanies(); // Refresh data if needed
      });
    },

    openRenewalDateDrawer(id,invoice_type) {
      this.companyId = id;
      this.invoiceType = invoice_type;
      this.renewalDateDrawer = true;
      EventBus.$emit("RENEWALDATE_DRAWER_STATE", true);
    },

    saveSearch() {
      // Save search value to localStorage
      if (this.search && this.search.length > 0) {
        localStorage.setItem('search-company', this.search);
      } else {
        localStorage.removeItem('search-company');
      }
    },

    loadSearch() {
      // Load search value from localStorage
      const savedSearch = localStorage.getItem('search-company');
      if (savedSearch !== null) {
        this.search = savedSearch;
        const searchKey = this.$globalConfig.APP_NAME == 'senso'
          ? '&search=company.company_name:'
          : '&search=company_name:';
        this.searchParams = searchKey + savedSearch;
      }
    },

    FilterByStatus(status) {
      if (typeof status != 'undefined' && status !== null)
        this.selectedStatus = '&state=' + status;
      else
        this.selectedStatus = '';

      this.getCompanies();

    },

    FilterByPartner(partners) {
      if (typeof partners != 'undefined' && partners !== null) {
        this.selectedPartners = '&partnerId=' + partners;
      } else {
        this.selectedPartners = '';
      }
      this.getCompanies();
    },

    getLeadsData() {
      improveAPI.getLeadsData().then((response) => {
        this.leads = response.data.data;
      });
    },
    FilterByLead(lead) {
      if (typeof lead != 'undefined' && lead !== null)
        this.selectedLead = '&lead_id=' + lead;
      else
        this.selectedLead = '';

      this.getCompanies();
    },
     openDialog(event, data, title) {
      this.dialogTitle = title;
      this.dialogData = data;
      this.dialog = true;
      document.getElementById('improve').style.pointerEvents = 'none';

    },
    closeDialog() {
      document.getElementById('improve').style.pointerEvents = 'unset';
    
      this.dialog = false;
    },
     getPartnersList(){
      this.partnerLoading = true;
       partnerAPI
        .getPartnersList()
        .then((response) => {
          this.partners = response.data.data;
          this.partnerLoading = false;
          this.partnersCopy = [...this.partners];
        });
    },
    onSearchInput(){
      // Triggered when user types in the search field
      if (!this.searchTerm) {
        this.partners = this.partnersCopy; // Reset to original if search is empty
      }

      // Filter the array by matching the `name` property
         this.partners = this.partnersCopy.filter((item) =>
           item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
         );
    },
     resetSearchTerm(){
          this.searchTerm = ""; // Clear the search term
          this.partners = this.partnersCopy; // Reset filtered fruits
     },

  },

};
</script>
<style type="text/css">
.v-input--selection-controls {
  padding-top: 6px !important;
  margin-top: 0px !important;
}
</style>
